export default function About() {

  return (
    <section className="space-y-8">
      <div className="rounded-2xl border border-orange-400/20 bg-black/20 p-8">
        <h1 className="text-3xl font-black uppercase tracking-wide">🎧✨ ¿Quiénes Somos?</h1>
        <p className="mt-4 leading-7 text-orange-50/85">
          En DJ Carbajal transformamos cada evento en una experiencia única. Somos un DJ versátil,
          apasionado por la música y capaz de transmitir emociones a través de cada ritmo, adaptándonos
          a todo tipo de celebraciones: XV años, bodas, bautizos, presentaciones, cumpleaños y más.
        </p>
        <p className="mt-4 leading-7 text-orange-50/85">
          Nuestra misión es crear momentos inolvidables, llevando la energía de la música a cada rincón
          y conectando con el público de manera auténtica. Con un estilo dinámico y profesional,
          garantizamos que cada fiesta se convierta en un recuerdo que perdure en la memoria de tus invitados.
        </p>
        <p className="mt-4 leading-7 italic text-orange-50/85">
          Porque no solo ponemos música… hacemos que la música hable por ti, que acompañe tus emociones
          y que cada instante se viva al máximo.
        </p>
      </div>

      <div className="rounded-2xl border border-orange-400/20 bg-black/20 p-8">
        <h2 className="text-2xl font-bold uppercase tracking-wide">📖✨ Historia</h2>
        <p className="mt-4 leading-7 text-orange-50/85">
          La pasión por la música en DJ Carbajal nació desde muy pequeño, acompañando a nuestro tío
          José Luis Carbajal y su legendario sonido Dinastía Rumbera. Desde los 13 años, entre bocinas
          y cables, aprendimos que la música no solo se escucha: se vive, se siente y se comparte.
        </p>
        <p className="mt-4 leading-7 text-orange-50/85">
          Aquellos primeros pasos como cargadores en los eventos fueron el inicio de un sueño. Observando
          cómo se conectaba cada equipo y cómo la música lograba transformar el ambiente, descubrimos
          nuestra vocación. Con el tiempo, aprendimos a dominar los nervios frente al público y a
          convertirlos en energía para animar y conectar con la gente.
        </p>
        <p className="mt-4 leading-7 text-orange-50/85">
          Tras años de experiencia y dedicación, en 2020 nace oficialmente DJ Carbajal, con la ilusión
          de crecer y llevar alegría a cada celebración. Hoy, con más de dos décadas de aprendizaje y
          pasión, seguimos fieles a nuestro propósito: hacer bailar, emocionar y crear recuerdos
          inolvidables a través de la música.
        </p>
      </div>
    </section>
  );
}
